import { cufrontIcons } from "../../../../cufront-assets/icons/Icons";
import { LuLayoutDashboard } from "react-icons/lu";
import { BiSolidDashboard } from "react-icons/bi";
import {
  BsCalendar2Minus,
  BsFileEarmarkMedicalFill,
  BsPeople,
} from "react-icons/bs";
import { BsCalendar2MinusFill } from "react-icons/bs";
import { RiEqualizerLine, RiMoneyDollarCircleFill } from "react-icons/ri";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import { IoSettingsOutline, IoSettingsSharp } from "react-icons/io5";
import { IoMdNotifications, IoMdNotificationsOutline } from "react-icons/io";
import {
  PiChatCircleDots,
  PiChatCircleDotsFill,
  PiChatCircleDotsLight,
} from "react-icons/pi";
import { BsPeopleFill } from "react-icons/bs";
import { RiEqualizerFill } from "react-icons/ri";
import { BsFileEarmarkMedical } from "react-icons/bs";
import { AiFillDollarCircle, AiOutlineDollar } from "react-icons/ai";
import "../css/Sidebar.css";
import { FEATURES } from "../../../../roles_and_permissions/_features";
import { FaAmbulance, FaMortarPestle, FaProcedures } from "react-icons/fa";

export const sidebarOptions = [
  {
    id: "1",
    name: "Dashboard",
    route: "/new/dashboard",
    featureId: FEATURES.dashboard.feature_id,
    activeIcon: (
      <BiSolidDashboard className="icons-react" color="#000000" size={"25px"} />
    ),
    inactiveIcon: (
      <LuLayoutDashboard
        className="icons-react"
        color="#999999"
        size={"25px"}
      />
    ),
  },
  {
    id: "2",
    name: "Appointment",
    route: "/new/appointment?all_clinic=false&view=day&session=All",
    featureId: FEATURES.appointment.feature_id,
    activeIcon: (
      <BsCalendar2MinusFill
        className="icons-react"
        color="#000000"
        size={"23px"}
      />
    ),
    inactiveIcon: (
      <BsCalendar2Minus className="icons-react" color="#999999" size={"23px"} />
    ),
  },
  // {
  //   id: "3",
  //   name: "Consultation",
  //   route: "/new/consultation",
  //   activeIcon: <BsFileEarmarkMedicalFill  className="icons-react" color="#000000" size={"25px"} />,
  //   inactiveIcon: <BsFileEarmarkMedical  className="icons-react" color="#999999" size={"25px"} />,
  // },
  {
    id: "9",
    name: "All Patient",
    route: "/new/all-patient?all_clinic=false",
    featureId: FEATURES.all_patient.feature_id,
    activeIcon: (
      <BsPeopleFill className="icons-react" color="#000000" size={"25px"} />
    ),
    inactiveIcon: <BsPeople color="#999999" size={"25px"} />,
  },
  {
    id: "4",
    name: "Finance and Accounting",
    route: "/new/invoice?option=invoice",
    featureId: FEATURES.finance_and_accounting.feature_id,
    activeIcon: (
      <AiFillDollarCircle
        className="icons-react"
        color="#000000"
        size={"28px"}
      />
    ),
    inactiveIcon: (
      <AiOutlineDollar className="icons-react" color="#999999" size={"28px"} />
    ),
  },
  {
    id: "5",
    name: "Emergency",
    route: "/new/emergency",
    featureId: FEATURES.emergency.feature_id,
    activeIcon: (
      <FaAmbulance className="icons-react" color="#000000" size={"25px"} />
    ),
    inactiveIcon: (
      <FaAmbulance className="icons-react" color="#999999" size={"25px"} />
    ),
  },
  {
    id: "6",
    name: "IPD",
    route: "/new/ipd",
    featureId: FEATURES.ipd.feature_id,
    activeIcon: (
      <FaProcedures className="icons-react" color="#000000" size={"25px"} />
    ),
    inactiveIcon: (
      <FaProcedures className="icons-react" color="#999999" size={"25px"} />
    ),
  },
  {
    id: "7",
    name: "Pharmacy",
    route: "/new/pharmacy",
    featureId: FEATURES.pharmacy.feature_id,
    activeIcon: (
      <FaMortarPestle className="icons-react" color="#000000" size={"25px"} />
    ),
    inactiveIcon: (
      <FaMortarPestle className="icons-react" color="#999999" size={"25px"} />
    ),
  },
  {
    id: "8",
    name: "Setup",
    route: "/new/setup",
    featureId: FEATURES.setup.feature_id,
    activeIcon: (
      <RiEqualizerFill className="icons-react" color="#000000" size={"25px"} />
    ),
    inactiveIcon: (
      <RiEqualizerLine className="icons-react" color="#999999" size={"25px"} />
    ),
  },

  // {
  //   id: "6",
  //   name: "Chat",
  //   route: "/new/chat",
  //   featureId: FEATURES.chat.feature_id,
  //   activeIcon: (
  //     <PiChatCircleDotsFill
  //       className="icons-react"
  //       color="#000000"
  //       size={"25px"}
  //     />
  //   ),
  //   inactiveIcon: (
  //     <PiChatCircleDots className="icons-react" color="#999999" size={"25px"} />
  //   ),
  // },
  // {
  //   id: "7",
  //   name: "Notifications",
  //   route: "/new/notifications",
  //   featureId: FEATURES.notification.feature_id,
  //   activeIcon: (
  //     <IoMdNotifications
  //       className="icons-react"
  //       color="#000000"
  //       size={"27px"}
  //     />
  //   ),
  //   inactiveIcon: (
  //     <IoMdNotificationsOutline
  //       className="icons-react"
  //       color="#999999"
  //       size={"27px"}
  //     />
  //   ),
  // },
  // {
  //   id: "8",
  //   name: "Profile",
  //   route: "/new/editprofile",
  //   featureId: FEATURES.settings.feature_id,
  //   activeIcon: (
  //     <IoSettingsSharp className="icons-react" color="#000000" size={"25px"} />
  //   ),
  //   inactiveIcon: (
  //     <IoSettingsOutline
  //       className="icons-react"
  //       color="#999999"
  //       size={"25px"}
  //     />
  //   ),
  // },
];

export const topbarOptions = [
  {
    id: 1,
    route: "/new/notifications",
    activeIcon: (
      <IoMdNotifications
        className="icons-react"
        color="#999999"
        size={"28px"}
      />
    ),
    inactiveIcon: (
      <IoMdNotificationsOutline
        className="icons-react"
        color="#999999"
        size={"35px"}
      />
    ),
    name: "Notifications",
  },
  {
    id: 2,
    route: "/new/chat",
    activeIcon: (
      <PiChatCircleDotsFill
        className="icons-react"
        color="#999999"
        size={"25px"}
      />
    ),
    inactiveIcon: (
      <PiChatCircleDots className="icons-react" color="#999999" size={"33px"} />
    ),
    name: "Chat",
  },

  {
    id: "3",
    name: "Setup",
    route: "/new/setup",
    activeIcon: (
      <RiEqualizerFill className="icons-react" color="#999999" size={"25px"} />
    ),
    inactiveIcon: (
      <RiEqualizerLine className="icons-react" color="#999999" size={"33px"} />
    ),
  },

  {
    id: "4",
    name: "Finance and Accounting",
    route: "/new/invoice?option=invoice",
    activeIcon: (
      <AiFillDollarCircle
        className="icons-react"
        color="#999999"
        size={"25px"}
      />
    ),
    inactiveIcon: (
      <AiOutlineDollar className="icons-react" color="#999999" size={"33px"} />
    ),
  },

  {
    id: "8",
    name: "Settings",
    route: "/new/settings",
    activeIcon: (
      <IoSettingsSharp className="icons-react" color="#999999" size={"25px"} />
    ),
    inactiveIcon: (
      <IoSettingsOutline
        className="icons-react"
        color="#999999"
        size={"33px"}
      />
    ),
  },
];

export const chatActive = cufrontIcons.chatActive;
export const chatInactive = cufrontIcons.chatInactive;
export const notificationActive = cufrontIcons.notificationActive;
export const notificationInactive = cufrontIcons.notificationInactive;

export const patientsSidebarOptions = [
  {
    id: "1",
    name: "Dashboard",
    route: "/p",
    activeIcon: cufrontIcons.homeActive,
    inactiveIcon: cufrontIcons.homeInactive,
  },
  {
    id: "2",
    name: "Appointment",
    route: "/p/appointment",
    activeIcon: cufrontIcons.appointmentActive,
    inactiveIcon: cufrontIcons.appointmentInactive,
  },
  {
    id: "3",
    name: "Record",
    route: "/p/record",
    activeIcon: cufrontIcons.medRecordActive,
    inactiveIcon: cufrontIcons.medRecordInactive,
  },
  {
    id: "4",
    name: "Profile",
    route: "/p/profile",
    activeIcon: cufrontIcons.profileActive,
    inactiveIcon: cufrontIcons.profileInactive,
  },
];

export const patientTopbarOptions = [
  {
    id: 1,
    route: "/p/notifications",
    activeIcon: cufrontIcons.notificationsActive,
    inactiveIcon: cufrontIcons.notificationsInactive,
  },
  {
    id: 2,
    route: "/p/chat",
    activeIcon: cufrontIcons.chatPngActive,
    inactiveIcon: cufrontIcons.chatPngInactive,
  },
  {
    id: 3,
    name: "Call",
    route: "/p/call",
    activeIcon: cufrontIcons.callActive,
    inactiveIcon: cufrontIcons.callInactive,
  },
];

export const editProfileInputConfigs = [
  { label: "Email", key: "email", type: "email" },
  {
    label: "Highest Qualification",
    key: "highest_qualification",
    type: "text",
  },
  { label: "Graduation Year", key: "graduation_year", type: "text" },
  { label: "Specialty", key: "specialty", type: "text" },
  { label: "Hospital Address", key: "hospital_address", type: "text" },
  {
    label: "State",
    key: "state",
    type: "select",
    options: [
      {
        key: "andhra_pradesh",
        value: "Andhra Pradesh",
        text: "Andhra Pradesh",
      },
      {
        key: "arunachal_pradesh",
        value: "Arunachal Pradesh",
        text: "Arunachal Pradesh",
      },
      { key: "assam", value: "Assam", text: "Assam" },
      { key: "bihar", value: "Bihar", text: "Bihar" },
      { key: "chhattisgarh", value: "Chhattisgarh", text: "Chhattisgarh" },
      { key: "goa", value: "Goa", text: "Goa" },
      { key: "gujarat", value: "Gujarat", text: "Gujarat" },
      { key: "haryana", value: "Haryana", text: "Haryana" },
      {
        key: "himachal_pradesh",
        value: "Himachal Pradesh",
        text: "Himachal Pradesh",
      },
      { key: "jharkhand", value: "Jharkhand", text: "Jharkhand" },
      { key: "karnataka", value: "Karnataka", text: "Karnataka" },
      { key: "kerala", value: "Kerala", text: "Kerala" },
      {
        key: "madhya_pradesh",
        value: "Madhya Pradesh",
        text: "Madhya Pradesh",
      },
      { key: "maharashtra", value: "Maharashtra", text: "Maharashtra" },
      { key: "manipur", value: "Manipur", text: "Manipur" },
      { key: "meghalaya", value: "Meghalaya", text: "Meghalaya" },
      { key: "mizoram", value: "Mizoram", text: "Mizoram" },
      { key: "nagaland", value: "Nagaland", text: "Nagaland" },
      { key: "odisha", value: "Odisha", text: "Odisha" },
      { key: "punjab", value: "Punjab", text: "Punjab" },
      { key: "rajasthan", value: "Rajasthan", text: "Rajasthan" },
      { key: "sikkim", value: "Sikkim", text: "Sikkim" },
      { key: "tamil_nadu", value: "Tamil Nadu", text: "Tamil Nadu" },
      { key: "telangana", value: "Telangana", text: "Telangana" },
      { key: "tripura", value: "Tripura", text: "Tripura" },
      { key: "uttar_pradesh", value: "Uttar Pradesh", text: "Uttar Pradesh" },
      { key: "uttarakhand", value: "Uttarakhand", text: "Uttarakhand" },
      { key: "west_bengal", value: "West Bengal", text: "West Bengal" },
    ],
  },
  { label: "Department", key: "department", type: "text" },
  {
    label: "Medical Registration Number",
    key: "medical_registration_number",
    type: "text",
  },
  { label: "Follow Up Period", key: "follow_up_period", type: "text" },
  { label: "Follow Up Fees", key: "follow_up_fees", type: "text" },
];
